import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/button';
import { ArrowRight, Shield, Search } from 'lucide-react';

const FinalCTASection = ({ onOpenContactForm }) => {
  return (
    <section data-testid="final-cta-section" className="py-28 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-[#3B82F6]/[0.08] via-transparent to-[#06B6D4]/[0.06]" />
      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}>
          <div className="w-16 h-16 rounded-2xl btn-gradient flex items-center justify-center mx-auto mb-8">
            <Shield className="w-8 h-8 text-white" />
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-white mb-6">
            Protect Your Logo <span className="text-gradient">Today</span>
          </h2>
          <p className="text-xl text-[#A1A1AA] leading-relaxed mb-10 max-w-2xl mx-auto">
            Don't wait until someone copies your brand. Start your trademark application now and secure legal ownership of your logo.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Button data-testid="final-cta-protect" onClick={onOpenContactForm}
              className="btn-gradient text-white font-semibold px-8 py-4 rounded-lg border-0 text-lg">
              Protect My Logo Now <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button data-testid="final-cta-search" onClick={onOpenContactForm}
              variant="outline" className="border-white/[0.15] text-white hover:bg-white/[0.05] font-semibold px-8 py-4 rounded-lg text-lg">
              <Search className="mr-2 w-5 h-5" /> Free Logo Trademark Search
            </Button>
          </div>
          <p className="text-sm text-[#52525B] mt-6">Start your trademark application today. Free consultation included.</p>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTASection;
